<template>
    <div class="MAM_terminalDetail">

            <el-dialog :visible="infoIsShow" @close="handleClose" :close-on-click-modal="false" >
                <el-card class="box-card" shadow="hover" >

                   <!-- <el-row class="rowTitle">
                        <el-col :sm="24" :md="24" :lg="24">
                            <span class="labels">入库时间：</span>
                            <span>{{viewData.terminal_in_time}}</span>
                        </el-col>
                        <el-col :sm="24" :md="24" :lg="24">
                            <span class="labels">划拨出库：</span>
                            <span></span>
                        </el-col>
                        <el-col :sm="24" :md="24" :lg="24">
                            <span class="labels">绑定：</span>
                            <span>{{viewData.bind_time}}</span>
                            <span>{{viewData.bind_name}}</span>
                        </el-col>
                        <el-col :sm="24" :md="24" :lg="24">
                            <span class="labels">激活：</span>
                            <span>{{viewData.active_time}}</span>
                            <span>{{viewData.reward_money}}</span>
                        </el-col>
                        <el-col :sm="24" :md="24" :lg="24">
                            <span class="labels">达标：</span>
                            <span>{{viewData.award_time}}</span>
                            <span>{{viewData.award_reward_money}}</span>
                        </el-col>
                        <el-col :sm="24" :md="24" :lg="24">
                            <span class="labels">阶梯：</span>
                            <span>{{viewData.ladder_award_time}}</span>
                            <span>{{viewData.ladder_award_reward_money}}</span>
                        </el-col>

                        <el-col :sm="24" :md="24" :lg="24">
                            <span class="labels">押金奖励：</span>
                            <span>{{viewData.cash_time}}</span>
                            <span>{{viewData.cash_reward}}</span>
                            <span>{{viewData.cash_deposit}}</span>
                        </el-col>

                        <el-col :sm="24" :md="24" :lg="24">
                            <span class="labels">流量卡奖励：</span>
                            <span>{{viewData.flow_time}}</span>
                            <span>{{viewData.flow_reward}}</span>
                            <span>{{viewData.flow_deposit}}</span>
                        </el-col>
                    </el-row>-->
                    <div  style="margin-top:20px" class="purseTitle">
                        <div style="color:red" align="center">入库时间</div>
                    </div>
                    <el-table :data="transferList.list.terminal_in_time"  size="mini" border style="width: 100%" v-loading="loading" v-if="level ==0" :header-cell-style="styleFunc" :show-header="false">
                        <!-- id -->
                        <el-table-column header-align="center" align="center" type="index" label="序号" width="60" ></el-table-column>
                        <!-- 入库时间 -->
                        <el-table-column header-align="center" align="center"  prop="update_time" label="入库时间" min-width="120"></el-table-column>
                    </el-table>

                    <!--出库入库记录-->
                    <div  style="margin-top:20px" class="purseTitle"><div style="color:red" align="center">出库入库记录</div></div>
                    <el-table :data="transferList.list.transfe" size="mini" border style="width: 100%" v-loading="loading" :header-cell-style="styleFunc">
                        <!-- id -->
                        <el-table-column header-align="center" align="center" type="index" label="序号" width="60"></el-table-column>
                        <!-- 入库时间 -->
                        <el-table-column header-align="center" align="center" prop="update_time" label="接受入库时间" min-width="120"></el-table-column>
                        <!-- 入库时间 -->
                        <el-table-column header-align="center" align="center" prop="nickname" label="接受对象" min-width="120"></el-table-column>
                    </el-table>

                    <!--退回记录-->
                    <div  style="margin-top:20px" class="purseTitle">
                        <div style="color:red" align="center">退回记录</div>
                    </div>
                    <el-table :data="transferList.list.return" size="mini" border style="width: 100%" v-loading="loading" :header-cell-style="styleFunc">
                        <!-- id -->
                        <el-table-column header-align="center" align="center" type="index" label="序号" width="60"></el-table-column>
                        <!-- 入库时间 -->
                        <el-table-column header-align="center" align="center" prop="update_time" label="退回时间" min-width="120"></el-table-column>
                        <!-- 入库时间 -->
                        <el-table-column header-align="center" align="center" prop="nickname" label="退回对象" min-width="120"></el-table-column>
                    </el-table>

                    <!--绑定-->
                    <div style="margin-top:20px" class="purseTitle">
                        <div style="color:red" align="center">绑定</div>
                    </div>
                    <el-table :data="transferList.list.bind_info" size="mini" border style="width: 100%" v-loading="loading" :header-cell-style="styleFunc">
                        <el-table-column header-align="center" align="center" type="index" label="序号" width="60"></el-table-column>
                        <el-table-column header-align="center" align="center" prop="bind_time" label="绑定时间" min-width="120"></el-table-column>
                        <el-table-column header-align="center" align="center" prop="name" label="商户名称" min-width="120"></el-table-column>
                    </el-table>

                    <!--激活-->
                    <div style="margin-top:20px" class="purseTitle">
                        <div style="color:red" align="center">激活</div>
                    </div>
                    <el-table :data="transferList.list.active_info" size="mini" border style="width: 100%" v-loading="loading" :header-cell-style="styleFunc">
                        <!-- id -->
                        <el-table-column header-align="center" align="center" type="index" label="序号" width="60"></el-table-column>
                        <!-- 入库时间 -->
                        <el-table-column header-align="center" align="center" prop="active_time" label="激活时间" min-width="120"></el-table-column>
                        <!-- 入库时间 -->
                        <el-table-column header-align="center" align="center" prop="reward_money" label="激活奖励" min-width="120"></el-table-column>
                    </el-table>

                    <!--达标奖励-->
                    <div style="margin-top:20px" class="purseTitle">
                        <div style="color:red" align="center">达标奖励</div>
                    </div>
                    <el-table :data="transferList.list.standaraward" size="mini" border style="width: 100%" v-loading="loading" :header-cell-style="styleFunc">
                        <!-- id -->
                        <el-table-column header-align="center" align="center" type="index" label="序号" width="60"></el-table-column>
                        <!-- 入库时间 -->
                        <el-table-column header-align="center" align="center" prop="award_time" label="达标时间" min-width="120"></el-table-column>
                        <!-- 入库时间 -->
                        <el-table-column header-align="center" align="center" prop="reward_money" label="达标奖励" min-width="120"></el-table-column>
                        <el-table-column header-align="center" align="center" prop="status" label="达标状态" min-width="120"></el-table-column>
                    </el-table>

                    <!--<div class="purseTitle">
                        <div style="color:red" align="center">阶梯奖励</div>
                    </div>
                    <el-table
                            :data="transferList.list.ladderaward"
                            size="mini"
                            border
                            style="width: 100%"
                            v-loading="loading"
                    >
                        &lt;!&ndash; id &ndash;&gt;
                        <el-table-column
                                header-align="center"
                                align="center"
                                type="index"
                                label="序号"
                                min-width="80"
                        ></el-table-column>
                        &lt;!&ndash; 入库时间 &ndash;&gt;
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="award_time"
                                label="奖励时间"
                                min-width="120"
                        ></el-table-column>
                        &lt;!&ndash; 入库时间 &ndash;&gt;
                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="reward_money"
                                label="奖励"
                                min-width="120"
                        ></el-table-column>
                    </el-table>-->

                    <div style="margin-top:20px" class="purseTitle">
                        <div style="color:red" align="center">押金奖励</div>
                    </div>
                    <el-table :data="transferList.list.cash" size="mini" border  v-loading="loading" :header-cell-style="styleFunc">
                        <!-- id -->
                        <el-table-column header-align="center" align="center" type="index" label="序号" width="60"></el-table-column>
                        <el-table-column header-align="center" align="center" prop="update_time" label="时间" min-width="200"></el-table-column>
                        <el-table-column header-align="center" align="center" prop="deposit" label="押金" min-width="120"></el-table-column>
                        <el-table-column header-align="center" align="center" prop="reward_money" label="政策" min-width="120"></el-table-column>
                        <el-table-column header-align="center" align="center" prop="cash_reward" label="奖励" min-width="120"></el-table-column>
                        <el-table-column header-align="center" align="center" prop="nickname" label="用户" width="350"></el-table-column>
                        <el-table-column header-align="center" align="center" style="color:green" prop="status" label="状态" min-width="120">
                            <template slot-scope="scope">
                                <p  v-if="scope.row.status=='已到账'" style="color:green" v-html="scope.row.status"></p>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div style="margin-top:20px" class="purseTitle">
                        <div style="color:red" align="center">流量卡奖励</div>
                    </div>
                    <el-table :data="transferList.list.flow" size="mini" border style="width: 100%" v-loading="loading" :header-cell-style="styleFunc">
                        <!-- id -->
                        <el-table-column header-align="center" align="center" type="index" label="序号" width="60"></el-table-column>
                        <el-table-column header-align="center" align="center" prop="update_time" label="时间" min-width="120"></el-table-column>
                        <el-table-column header-align="center" align="center" prop="deposit" label="流量卡" min-width="120" ></el-table-column>
                        <el-table-column header-align="center" align="center" prop="reward_money" label="政策" min-width="120"></el-table-column>
                        <el-table-column header-align="center" align="center" prop="flow_reward" label="奖励" min-width="120"></el-table-column>
                        <el-table-column header-align="center" align="center" prop="nickname" label="用户" width="350"></el-table-column>
                        <el-table-column header-align="center" align="center" prop="status" label="状态" min-width="120">
                            <template slot-scope="scope">
                                <p  v-if="scope.row.status=='已到账'" style="color:green" v-html="scope.row.status"></p>
                            </template>
                        </el-table-column>
                    </el-table>

                   <!-- <div class="purseTitle">
                        <div style="color:red" align="center">伪激活扣款</div>
                    </div>
                    <el-table
                            :data="transferList.list.risk"
                            size="mini"
                            border
                            style="width: 100%"
                            v-loading="loading"
                    >
                        &lt;!&ndash; id &ndash;&gt;
                        <el-table-column
                                header-align="center"
                                align="center"
                                type="index"
                                label="序号"
                                min-width="80"
                        ></el-table-column>

                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="end_time"
                                label="时间"
                                min-width="120"
                        ></el-table-column>

                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="deduction_money"
                                label="被扣"
                                min-width="120"
                        ></el-table-column>

                        <el-table-column
                                header-align="center"
                                align="center"
                                prop="deduction_money"
                                label="扣回"
                                min-width="120"
                        ></el-table-column>
                    </el-table>-->
                    <!--延迟激活记录表格 -->
                    <!-- <div class="purseTitle aelay_table">
                        <div style="color:red" align="center">延长激活记录</div>
                    </div>
                    <el-table class="aelay_table" :data="aelay.AelayActivList" size="mini" border style="width: 100%" :header-cell-style="styleFunc">
                        <el-table-column header-align="center" align="center" type="index" label="序号" width="60"></el-table-column>
                        <el-table-column prop="nickname" align="center" label="延长人员" width="180"></el-table-column>
                        <el-table-column prop="phone" align="center" label="手机号" width="180"></el-table-column>
                        <el-table-column prop="days" align="center" label="延长天数" width="180"></el-table-column>
                        <el-table-column prop="create_time" align="center" label="修改时间"></el-table-column>
                    </el-table>
                    <div class="aelay_activ_list_page">
                        <el-pagination background layout="prev, pager, next" :total="aelay.count" @current-change="nextPage"></el-pagination>
                    </div> -->

                </el-card>
            </el-dialog>
    </div>
</template>

<script>
export default {
    name: "MAM_terminalDetail",
    props: {
        infoIsShow: {
            type: Boolean,
            default: false
        },
        detail: {
            type: Object
        }
    },
    data() {
        return {
            level:sessionStorage.getItem('level'),
            transctionInfoTable: [], //表格
            viewData: {},
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 0  //总数
            },

            id: null,
            loading: true,
            transferList: {
                list: [],
            },
            //激活时间列表
            aelay:{
                page:1,
                AelayActivList:[],//列表数据
                count:0,//总条数
            },



        }
    },
    mounted() {
        this.id = this.detail.id;
        this.getData();
        //获取激活延期列表
        this.getAelayActivList()
    },
    methods: {
        handleClose() {
            this.$emit('infoClose')
        },
        getData() { //获取数据
            this.$api.post('terminal_equipment/get_terminal_equipment_info',{ id: this.detail.id }, res => {
                let data = res.data;
                this.transferList.list = res.data.list;
                this.transferList.list.terminal_in_time = res.data.list.terminal_in_time;
                this.transferList.list.transfe = res.data.list.transfe;
                this.transferList.list.bind_info = res.data.list.bind_info;
                this.transferList.list.active_info = res.data.list.active_info;
                this.transferList.list.standaraward = res.data.list.standaraward;
                this.transferList.list.ladderaward = res.data.list.ladderaward;
                this.transferList.list.cash = res.data.list.cash;
                this.transferList.list.flow = res.data.list.flow;
                this.transferList.list.risk = res.data.list.risk;
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        //获取激活延期
        getAelayActivList(){
            var obj = {
                id:this.detail.id,
                page:this.aelay.page
            }
            this.$api.post('terminal/getAelayActivList',obj , res => {
                if(res.code == 0){
                    this.aelay.count = res.data.count
                    this.aelay.AelayActivList = res.data.data
                }
            })
        },
        //切换分页
        nextPage(res){
            this.aelay.page = res
            this.getAelayActivList();
        },
        //修改表头样式
        styleFunc({row,column,rowIndex, columnIndex}){
            return 'color:#333!important;background-color:#f6f7fb;font-size:15px !important'
        }
    }
};
</script>

<style scoped lang="scss">
.MAM_terminalDetail {
    font-size: 12px;
    .el-input__inner,
    .tips {
        font-size: 12px;
    }

    .el-form-item {
        margin-bottom: 5px;
    }

    ::v-deep .el-form-item__label {
        padding: 0;
        font-size: 12px;
    }
    .titleTip {
        padding: 10px 10px;
        background-color: #ecf8ff;
        border-radius: 4px;
        font-size: 13px;
        font-weight: 700;
        border-left: 5px solid #50bfff;
        margin: 10px 0;
    }
    .title p {
        font-size: 12px;
        :first-child {
            font-weight: 700;
        }
    }
    .aelay_activ_list_page{display:flex;justify-content:center;margin-top:20px;}
    .aelay_table{margin-top:20px}
    .purseTitle{margin:20px 0;}
    .purseTitle div{color:#000000 !important;font-weight:bold !important;font-size:15px !important}



}
</style>